import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faTint, faMobileAlt, faDesktop } from '@fortawesome/pro-solid-svg-icons';

export const previewTypes = {
  web: 'web',
  mobile: 'mobile',
  html: 'html',
  liquid: 'liquid'
};

class PreviewType extends React.Component {
  static propTypes = {
    designer: PropTypes.bool,
    previewType: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  }

  selectWeb = () => {
    this.props.onChange(previewTypes.web);
  }

  selectMobile = () => {
    this.props.onChange(previewTypes.mobile);
  }

  selectHtml = () => {
    this.props.onChange(previewTypes.html);
  }

  selectLiquid = () => {
    this.props.onChange(previewTypes.liquid);
  }

  render() {
    return (
      <div className="email-preview-type">
        {this.renderIcon(faDesktop, previewTypes.web, this.selectWeb)}
        {this.renderIcon(faMobileAlt, previewTypes.mobile, this.selectMobile)}
        {this.renderIcon(faCode, previewTypes.html, this.selectHtml)}
        {this.props.designer ? this.renderIcon(faTint, previewTypes.liquid, this.selectLiquid) : null}
      </div>
    );
  }

  renderIcon(icon, previewType, onClick) {
    return (
      <div
        className={`icon ${this.props.previewType === previewType ? 'active' : ''}`}
        name={previewType}
        onClick={onClick}
      >
        <FontAwesomeIcon icon={icon} />
      </div>
    );
  }
}

export default PreviewType;
